import { render } from "./S160073.vue?vue&type=template&id=485a0ac2"
const script = {}
script.render = render

export default script